// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__FooterCountrySelect from "./FooterCountrySelect.js";
import * as Buhta_landing__FooterForm from "./FooterForm.js";
import * as Buhta_landing__FooterFormMobile from "./FooterFormMobile.js";
import * as Buhta_landing__FooterLanguageSelect from "./FooterLanguageSelect.js";
import * as Buhta_landing__FooterMenu from "./FooterMenu.js";
import * as Buhta_landing__FooterMenuMobile from "./FooterMenuMobile.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_models__Cms from "../../../../../../packages/models/Cms.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as QrcodeReact from "qrcode.react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function Footer(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const country = Buhta_landing__Route.getCountry(undefined);
  const deviceType = state.deviceType;
  const intl = ReactIntl.useIntl();
  const binLabel = Buhta_landing__I18n.trans(intl, "bin");
  const phoneLabel = Buhta_landing__I18n.trans(intl, "phone");
  const iikLabel = Buhta_landing__I18n.trans(intl, "iik");
  const bikLabel = Buhta_landing__I18n.trans(intl, "bik");
  const innLabel = Buhta_landing__I18n.trans(intl, "inn");
  const okpoLabel = Buhta_landing__I18n.trans(intl, "okpo");
  const accountLabel = Buhta_landing__I18n.trans(intl, "account");
  const okedLabel = Buhta_landing__I18n.trans(intl, "oked");
  const mfoLabel = Buhta_landing__I18n.trans(intl, "mfo");
  const siteLabel = Buhta_landing__I18n.trans(intl, "site");
  const addressLabel = Buhta_landing__I18n.trans(intl, "address");
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const requisites = match[0].requisites;
  let requisite;
  try {
    requisite = Stdlib__List.find((function (r) {
      return r.country === Buhta_models__Locale.toCountryString(country);
    }), requisites);
  }
  catch (exn){
    requisite = Buhta_models__Cms.Requisites.$$default;
  }
  const site = requisite.site;
  const email = requisite.email;
  const phone = requisite.phone;
  const address = requisite.address;
  const bank = requisite.bank;
  const name = requisite.name;
  const bin = Belt__Belt_Option.getWithDefault(requisite.bin, "-");
  const oked = Belt__Belt_Option.getWithDefault(requisite.oked, "-");
  const iik = Belt__Belt_Option.getWithDefault(requisite.iik, "-");
  const bik = Belt__Belt_Option.getWithDefault(requisite.bik, "-");
  const inn = Belt__Belt_Option.getWithDefault(requisite.inn, "-");
  const okpo = Belt__Belt_Option.getWithDefault(requisite.okpo, "-");
  const account = Belt__Belt_Option.getWithDefault(requisite.account, "-");
  const mfo = Belt__Belt_Option.getWithDefault(requisite.mfo, "-");
  let details;
  let exit = 0;
  switch (country) {
    case /* COUNTRY_UNSPECIFIED */ 0 :
    case /* COUNTRY_KAZ */ 1 :
      exit = 1;
      break;
    case /* COUNTRY_KGZ */ 2 :
      details = "" + name + ". " + innLabel + ": " + inn + ". " + okpoLabel + ": " + okpo + ". " + bank + ". " + accountLabel + ": " + account + ". " + bikLabel + ": " + bik + ". " + addressLabel + ": " + address + ". " + phoneLabel + ": " + phone + ". Email: " + email + ". " + siteLabel + ": " + site;
      break;
    case /* COUNTRY_UZB */ 3 :
      details = "" + name + ". " + innLabel + ": " + inn + ". " + okedLabel + ": " + oked + ". " + accountLabel + ": " + account + ". " + bank + ". " + mfoLabel + ": " + mfo + ". " + addressLabel + ": " + address + ". " + phoneLabel + ": " + phone + ". Email: " + email + ". " + siteLabel + ": " + site;
      break;
  }
  if (exit === 1) {
    details = "" + name + ". " + binLabel + ": " + bin + ". " + bank + ". " + iikLabel + ": " + iik + ". " + bikLabel + ": " + bik + ". " + addressLabel + ": " + address + ". " + phoneLabel + ": " + phone + ". Email: " + email + ". " + siteLabel + ": " + site;
  }
  const license = requisite.license;
  const privacy = requisite.privacy;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h3", {
                children: Buhta_landing__I18n.trans(intl, "start_using_it"),
                className: "h4 lg:h3 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: Buhta_landing__I18n.trans(intl, "we_will_ease_and_accelerate_all_business_processes"),
                className: "paragraph lg:paragraph-large text-black-landing mt-2"
              })
            ]
          }),
          deviceType === "mobile" ? null : JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("p", {
                  children: "Скачать приложение",
                  className: "paragraph text-white w-25"
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(QrcodeReact.QRCodeSVG, {
                    value: "https://buhta.com/app",
                    size: 68
                  }),
                  className: "p-1 rounded-lg bg-white"
                })
              ],
              className: "bg-gray-light-landing rounded-lg p-1 pl-7 flex gap-5 items-center"
            })
        ],
        className: "flex justify-between m-auto lg:w-252"
      }),
      deviceType === "mobile" ? JsxRuntime.jsx(Buhta_landing__FooterFormMobile.make, {}) : JsxRuntime.jsx(Buhta_landing__FooterForm.make, {}),
      deviceType === "mobile" ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("hr", {
              className: "text-divider"
            }),
            JsxRuntime.jsxs("a", {
              children: [
                JsxRuntime.jsx("img", {
                  className: "w-6 h-6",
                  alt: "Б",
                  src: StaticAsset.src("/static/icons/logo-square-rounded-24.svg")
                }),
                JsxRuntime.jsx("p", {
                  children: "Скачать приложение",
                  className: "paragraph-medium text-white"
                })
              ],
              className: "bg-gray-light-landing rounded-lg flex justify-center mt-8 gap-4 py-3.5",
              href: "/app"
            })
          ],
          className: "mt-8"
        }) : null,
      deviceType === "mobile" || deviceType === "tablet" ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("hr", {
              className: "text-divider my-8"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                  className: "-mt-1.5",
                  src: StaticAsset.src("/static/icons/brand-glovo.svg")
                }),
                JsxRuntime.jsx("img", {
                  src: StaticAsset.src("/static/icons/yandex.svg")
                })
              ],
              className: "flex justify-between sm:justify-around w-full"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                  src: StaticAsset.src("/static/icons/jusan.svg")
                }),
                JsxRuntime.jsx("img", {
                  src: StaticAsset.src("/static/icons/visa-light.svg")
                })
              ],
              className: "flex justify-between sm:justify-around w-full mt-4"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                  src: StaticAsset.src("/static/icons/brand-indriver.svg")
                }),
                JsxRuntime.jsx("img", {
                  className: "h-10",
                  alt: "astana hub",
                  src: StaticAsset.src("/static/images/astana_hub.png")
                })
              ],
              className: "flex justify-between sm:justify-around w-full mt-4 items-center"
            })
          ]
        }) : JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
              className: "-mt-1.5",
              src: StaticAsset.src("/static/icons/brand-glovo.svg")
            }),
            JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/yandex.svg")
            }),
            JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/jusan.svg")
            }),
            JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/visa-light.svg")
            }),
            JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/brand-indriver.svg")
            }),
            JsxRuntime.jsx("img", {
              className: "h-10",
              alt: "astana hub",
              src: StaticAsset.src("/static/images/astana_hub.png")
            })
          ],
          className: "flex m-auto justify-between w-252 pt-24 items-center"
        }),
      JsxRuntime.jsx("hr", {
        className: "flex m-auto mt-8 lg:w-252 text-divider"
      }),
      deviceType === "mobile" ? JsxRuntime.jsx(Buhta_landing__FooterMenuMobile.make, {}) : JsxRuntime.jsx(Buhta_landing__FooterMenu.make, {}),
      JsxRuntime.jsx("hr", {
        className: "lg:flex lg:mx-auto mt-8 lg:w-252 text-divider"
      }),
      JsxRuntime.jsx("p", {
        children: details,
        className: "caption lg:flex lg:mx-auto mt-8 lg:w-252 text-gray-light-landing"
      }),
      license !== undefined ? JsxRuntime.jsx("p", {
          children: license,
          className: "caption lg:flex lg:mx-auto mt-3 lg:w-252 text-gray-light-landing"
        }) : null,
      privacy !== undefined ? JsxRuntime.jsx("p", {
          children: privacy,
          className: "caption lg:flex lg:mx-auto mt-3 lg:w-252 text-gray-light-landing"
        }) : null,
      JsxRuntime.jsx("hr", {
        className: "lg:flex lg:mx-auto mt-8 lg:w-252 text-divider"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
            children: Buhta_landing__I18n.trans(intl, "copyright"),
            className: "caption text-gray-light-landing"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_landing__FooterCountrySelect.make, {}),
              JsxRuntime.jsx(Buhta_landing__FooterLanguageSelect.make, {})
            ],
            className: "flex mt-6 lg:mt-0"
          })
        ],
        className: "lg:flex lg:mx-auto justify-between pt-6 lg:w-252"
      })
    ],
    className: "bg-bg pt-8 lg:pt-16 pb-6 px-6 sm:px-24 lg:px-0"
  });
}

const make = Footer;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
